import React from 'react';
import Slider from 'react-slick';
//import s from '../../layouts/desktop/EtimesListing.scss';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import SectionHeader from 'components_v2/common/SectionHeader';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';

const ListView = ({ item, s }) => {
  const settings = {
    dots: true,
    slidesToShow: item.slidesToShow,
    slidesToScroll: item.slidesToScroll,
    infinite: item?.infinite,
    centerMode: item?.centerMode,
    className: item?.centerMode ? 'center' : '',
  };
  return (
    <div className={item.classNames.map(i => s[i]).join(' ')}>
      {item.name && (
        <SectionHeader
          title={item.name}
          icon={item.icon}
          path={item.path}
          sponseredText={item.sponser?.sponseredText}
          sponseredLogo={item.sponser?.sponseredLogo}
          sponseredLink={item.sponser?.sponseredLink}
          ga4Type={item.ga4Type}
        />
      )}
      {!item.withoutSlick && (
        <div className="slick_UI smallArrow smallArrowBlack dark_theme">
          <Slider {...settings}>
            {item.items &&
              Array.isArray(item.items) &&
              item.items.map(it => (
                <ErrorBoundary>
                  <NewStoryCard
                    title={it?.hl}
                    msid={it?.msid}
                    syn={it?.synopsis}
                    isBigHeading={it?.isBigHeading}
                    isLarge={it?.isLarge}
                    cardType={it?.tn}
                    wu={it?.wu}
                    criticRating={it?.criticRating}
                    iconClass={it?.iconClass}
                    gaIndex={it?.gaIndex}
                    ga4Type={item.ga4Type}
                    cmstype={it?.cmstype}
                    ga4Label={it?.ga4Label}
                    videoTime={it?.videoTime}
                    createdTime={it?.createdTime}
                    createdTime2={it?.createdTime2}
                    fromToiPrint={it?.fromToiPrint}
                  />
                </ErrorBoundary>
              ))}
          </Slider>
        </div>
      )}
      {item.withoutSlick && (
        <div
          className={
            item.innerClassNames &&
            Array.isArray(item.innerClassNames) &&
            item.innerClassNames.map(i => s[i]).join(' ')
          }
        >
          {item.items &&
            Array.isArray(item.items) &&
            item.items.map(it => (
              <ErrorBoundary>
                <NewStoryCard
                  title={it.hl}
                  msid={it.msid}
                  syn={it.synopsis}
                  isBigHeading={it.isBigHeading}
                  isLarge={it.isLarge}
                  cardType={it.tn}
                  wu={it.wu}
                  criticRating={it.criticRating}
                  iconClass={it.iconClass}
                  gaIndex={it.gaIndex}
                  ga4Type={item.ga4Type}
                  cmstype={it.cmstype}
                  ga4Label={it.ga4Label}
                  videoTime={it?.videoTime}
                  createdTime={it?.createdTime}
                  createdTime2={it?.createdTime2}
                  fromToiPrint={it?.fromToiPrint}
                />
              </ErrorBoundary>
            ))}
        </div>
      )}
    </div>
  );
};

export default ListView;
